/* Clocked Out — bulk-saving correction. Added 13 Oct 2026.

   The "Save $X vs N single packs" line is rendered once in co-buybox.liquid
   from one-time prices:

     assign single_price = p.variants.first.price
     assign bulk_save = single_price | times: i | minus: v.price

   Both sides of that subtraction are one-time prices, so the figure never
   changed when the shopper switched to Subscribe & Save — it compared a
   one-time single pack against a subscription price, overstating the saving:

     60 Sleeps  sub  showed $36.99,  true saving $33.29  ($116.98 - $83.69)
     90 Sleeps  sub  showed $69.98,  true saving $62.98  ($175.47 - $112.49)

   Every pack button already carries data-otp and data-sub, so the correct
   comparison can be made client side without touching the buy box markup.
   This recomputes the line against the single pack at whichever plan is
   currently selected.

   Ordering: co-base.js binds its handler to the pack / plan button itself and
   sets aria-pressed inside it. This listener is on document, so bubbling
   guarantees it runs after that handler has already updated the DOM — no
   timeout needed, and the line changes in the same frame as the price. */
(function () {
  function amount(s) {
    var t = String(s == null ? '' : s).replace(/[^0-9.,]/g, '').replace(/,(?=\d{3}\b)/g, '');
    var n = parseFloat(t.replace(/,/g, '.'));
    return isNaN(n) ? null : n;
  }
  function moneyLike(sample, value) {
    var m = String(sample == null ? '' : sample).match(/^(\D*)([\d.,]+)(\D*)$/);
    return (m ? m[1] : '$') + value.toFixed(2) + (m ? m[3] : '');
  }
  function subActive(root) {
    var b = root.querySelector('.co-opt[data-plan-type="sub"]');
    return !!(b && b.getAttribute('aria-pressed') === 'true');
  }
  function apply(root) {
    var packs = root.querySelectorAll('.co-pack');
    if (!packs.length) return;
    var first = packs[0];
    var subMode = subActive(root);
    packs.forEach(function (el, idx) {
      var bulkEl = el.querySelector('.co-pack__bulk');
      if (!bulkEl) return;
      if (idx === 0) { bulkEl.hidden = true; return; }
      var useSub = subMode && el.getAttribute('data-plan-id') && first.getAttribute('data-plan-id');
      var attr = useSub ? 'data-sub' : 'data-otp';
      var singleStr = first.getAttribute(attr);
      var single = amount(singleStr);
      var mine = amount(el.getAttribute(attr));
      if (single == null || mine == null) { bulkEl.hidden = true; return; }
      var n = idx + 1;
      var diff = single * n - mine;
      if (!(diff > 0)) { bulkEl.hidden = true; return; }
      bulkEl.hidden = false;
      bulkEl.textContent = 'Save ' + moneyLike(singleStr, diff) + ' vs ' + n + ' single packs';
    });
  }
  function applyAll() {
    document.querySelectorAll('[data-co-buybox]').forEach(apply);
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (!t.closest('[data-co-buybox]')) return;
    applyAll();
  });
  document.addEventListener('DOMContentLoaded', applyAll);
  window.addEventListener('load', applyAll);
  document.addEventListener('shopify:section:load', function () { setTimeout(applyAll, 0); });
})();
